import React, { Component } from 'react';
import { Context } from 'context';

import Window from 'editor/workspace/window/Window';

import { Rnd } from 'react-rnd';
import equals from 'fast-deep-equal';

import styles from 'editor/workspace/workspace.module.scss';

class Workspace extends Component {
    static contextType = Context;

    workspace = React.createRef();

    state = {
        workspaceWidth: null,
        clipboard: {}
    };

    /**
     * Stops unnecessary rendering
     * @param nextProps
     * @param nextState
     * @param nextContext
     * @returns {boolean}
     */
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const windowsChanged = !equals(this.context.windows, nextContext.windows);
        const workspaceWidthChanged = this.state.workspaceWidth !== nextState.workspaceWidth;
        const clipboardChanged = !equals(this.state.clipboard, nextState.clipboard);
        // const folderStructureChanged = !equal(this.context.folderStructure, nextContext.folderStructure);

        return windowsChanged || workspaceWidthChanged || clipboardChanged;
    }

    componentDidMount() {
        this.setState({
            workspaceWidth: this.workspace.current.clientWidth
        });

        this.handleResize();

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("mousemove", () => {
            if(this.props.navigatorResize) this.handleResize();
        });
    }

    componentDidUpdate() {
        this.handleResize();
        if(!this.state.workspaceWidth) {
            this.setState({
                workspaceWidth: this.workspace.current.clientWidth
            })
        }
    }

    /**
     * Move each window in the workspace if it overflows following a browser resize
     */
    handleResize = () => {
        if(this.workspace.current){
            const availableX = this.workspace.current.clientWidth;
            const availableY = this.workspace.current.clientHeight - 3;
            const windows = this.context.windows;

            windows.forEach((window, i) => {
                if(this[`window-${i}`].window.current){
                    const element = this[`window-${i}`];

                    const width = element.window.current.clientWidth;
                    const height = element.window.current.clientHeight;

                    let x = element.props.window.position.x;
                    let y = element.props.window.position.y;

                    if(width + x > availableX){
                        const overflow = width + x - availableX;
                        x = x - overflow >= 0 ? x - overflow : 0;
                    }

                    if(height + y > availableY){
                        const overflow = height + y - availableY;
                        y = y - overflow >= 0 ? y - overflow : 0;
                    }

                    this.context.updateWindowPos(window.mapId, x, y);
                }
            });

            this.setState({
                workspaceWidth: availableX
            });
        }
    };

    /**
     * Save the current clipboard to state
     * @param {Object} table
     */
    setClipboard = (table) => {
        this.setState({
            clipboard: table
        })
    }


    render() {
        return (
            <div className={`${styles.workspace} ${this.context.lightTheme ? styles.light : ""}`}>
                <div className={styles.windows} ref={this.workspace}>
                    {this.context.windows.map((window, idx) => {
                        return (
                            <Rnd
                                key={window.mapId}
                                position = {{
                                    x: window.position.x,
                                    y: window.position.y,
                                }}
                                maxWidth = {this.state.workspaceWidth - window.position.x}
                                style={{zIndex: idx}}
                                enableResizing = {false}
                                bounds = "parent"
                                dragHandleClassName="handle"
                                onDragStop = {(e, d) => {
                                    this.context.updateWindowPos(window.mapId, d.x, d.y);
                                }}
                            >
                                <Window
                                    key={window.mapId}
                                    idx={idx}
                                    window={window}
                                    focused={idx === this.context.windows.length - 1}
                                    ref={el => this[`window-${idx}`] = el}
                                    handleResize={this.handleResize}
                                    clipboard={this.state.clipboard}
                                    setClipboard={this.setClipboard}
                                    map={this.context.loadedMaps[window.mapId]}
                                    updateHexToFrom={this.props.updateHexToFrom}
                                />
                            </Rnd>
                        )
                    })}
                </div>
            </div>
        )        
    }
}

export default Workspace;